import React from "react";
import {
  Box,
  Typography,
  Button,
  alpha,
  useTheme,
  Divider,
} from "@mui/material";
import { Receipt } from "@mui/icons-material";

/**
 * CartFooter Component
 * Displays cart totals and place order button
 */
const CartFooter = ({
  total,
  itemCount,
  onPlaceOrder,
  disabled,
  buttonLabel = "Place Order",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.25,
        borderTop: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
        bgcolor: "white",
        flexShrink: 0,
      }}
    >
      {/* Subtotal and Total */}
      <Box sx={{ mb: 1.25 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0.75,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Subtotal
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            Rs. {total.toFixed(2)}
          </Typography>
        </Box>

        <Divider sx={{ my: 0.75 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            Total
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 800,
              color: theme.palette.primary.main,
              fontSize: "1.125rem",
            }}
          >
            Rs. {total.toFixed(2)}
          </Typography>
        </Box>
      </Box>

      {/* Place Order Button */}
      <Button
        fullWidth
        variant="contained"
        size="large"
        disabled={disabled}
        onClick={onPlaceOrder}
        startIcon={<Receipt sx={{ fontSize: 28 }} />}
        sx={{
          minHeight: 64,
          py: 1.75,
          borderRadius: 2,
          fontWeight: 800,
          fontSize: "1.25rem",
          letterSpacing: 0.2,
          textTransform: "none",
          boxShadow: disabled ? 0 : 4,
          "&:hover": {
            boxShadow: disabled ? 0 : 5,
          },
          "&:active": {
            transform: disabled ? "none" : "scale(0.98)",
          },
          transition: "all 0.2s ease",
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};

export default CartFooter;
